'use client';

import { CardWithTitle, Form, Link } from '@packages/chakra-v3';

import { APP_ROUTES } from '@/routes';
import { Fragment } from 'react';
import { RegisterForm } from '../../components';
import { RegisterFormSchema } from '../../schemas';
import useRegister from '../../hooks/useRegister';

const RegisterContainer = () => {
	const { handleGoBack, handleRegisterUser } = useRegister();

	return (
		<CardWithTitle
			description={
				<Fragment>
					Already have an account?
					{' '}
					<Link href={APP_ROUTES.AUTH.LOGIN}> Login</Link>
				</Fragment>
			}
			title={'Register'}
		>
			<Form.Provider
				schema={RegisterFormSchema}
				onSubmit={handleRegisterUser}
			>
				<RegisterForm onClickBack={handleGoBack} />
			</Form.Provider>
		</CardWithTitle>
	);
};

export default RegisterContainer;